import { InjectionToken } from '@angular/core';
import type { MuiCard } from './mui-card.component';


export const MUI_CARD = new InjectionToken<MuiCard>('MUI_CARD');
